const KEY = 'balance_query_limits_snapshot';

export function readBalanceSnapshot() {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || {};
  } catch {
    return {};
  }
}

export function writeBalanceSnapshot(cards) {
  const snapshot = cards.reduce((acc, { productId, available, rechargePerSale }) => ({
    ...acc,
    [productId]: { available, rechargePerSale },
  }), {});

  try {
    localStorage.setItem(KEY, JSON.stringify(snapshot));
  } catch {
    // localStorage unavailable/full — the next read just misses the cache, nothing breaks
  }
}
